import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { PlaybookCommunicationService } from '../../../shared/services/playbook-communication.service';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { DefaultLanguageId, imageAllowedExtension } from 'src/app/shared/constants';
import { devicePixelRatio, Modalconfig } from 'src/app/shared/constants';
import { ChallengeBlock, Challenge } from 'src/app/shared/model/coaching-challenge';
import { includes, forEach } from 'lodash';
import { Subject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-add-edit-challenge-block',
    templateUrl: './add-edit-challenge-block.component.html',
    styleUrls: ['./add-edit-challenge-block.component.scss'],
    standalone: false
})
export class AddEditChallengeBlockComponent implements OnInit, OnDestroy {

  isdraftmode: boolean;
  pageId: number;
  sectionId: number;
  challengeBlock: ChallengeBlock;
  adminId: number;
  contentBlockId: number;
  playbookId: number;
  companyId: number;
  challenges: Challenge[];
  selectedFile: any;
  uploadedImg: any = {};
  selectedChallenge: Challenge;
  isLoaded = false;
  isTypeBtn: boolean;
  isTypeImg: boolean;
  progressbarDisplay = false;
  dynamicProgressbar: number;
  buttonText: string;
  devicePixelRatio = devicePixelRatio;
  isPrivateChallenge = false;
  privateChallengeId: number;
  confirmationModalRef: BsModalRef;
  confModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  defaultLanguageId = DefaultLanguageId;
  languageId: number;
  openFromMobile: boolean;
  onclose = new Subject();

  private confModalSubscription: Subscription;

  constructor(
    private modalRef: BsModalRef,
    private commonHttpService: CommonHttpService,
    private commService: PlaybookCommunicationService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.companyId = this.commService.Playbook ? this.commService.Playbook.companyId : 0;
    this.languageId = +this.activatedRoute.snapshot.queryParams.languageId || this.defaultLanguageId;
    if (!this.challengeBlock || (this.challengeBlock && !this.challengeBlock.onlineAssetId)) {
      // button type challenge block
      this.isTypeBtn = true;
      this.isTypeImg = false;
      this.buttonText = this.challengeBlock ? this.challengeBlock.buttonText : 'Go to the Challenge';
    } else if (this.challengeBlock && this.challengeBlock.onlineAssetId) {
      // image type challenge block
      this.isTypeImg = true;
      this.isTypeBtn = false;
      this.uploadedImg.id = this.challengeBlock.onlineAssetId;
    }
    this.fetchChallenges();
  }

  /**
   * To fetch challenges
   */
  fetchChallenges() {
    this.commonHttpService.get({
      uri: '/api/Challenge/GetChallengesByAdminId?adminId=' + this.adminId + '&companyId=' + this.companyId
    }).subscribe((response: Challenge[]) => {
      this.isLoaded = true;
      this.challenges = response;
      this.setSelectedChallenge();
    });
  }

  /**
   * To set selected challenge in case of update
   */
  setSelectedChallenge() {
    if (this.challengeBlock) {
      forEach(this.challenges, (challenge) => {
        if (this.challengeBlock.challengeId === challenge.challengeId) {
          this.selectedChallenge = challenge;
        }
      });
      if (!this.selectedChallenge) {
        // in case of private challenge
        this.selectedChallenge = new Challenge();
        this.isPrivateChallenge = true;
        this.selectedChallenge.challengeId = this.challengeBlock.challengeId;
        this.privateChallengeId = this.selectedChallenge.challengeId;
      }
    }
  }

  /**
   * To select challenge
   * @param challenge selected challenge
   */
  selectChallenge(challenge: Challenge) {
    this.selectedChallenge = challenge;
  }

  /**
   * To switch between block types from radio buttons
   * @param isBtn true for button type, false for image type
   */
  setBlockType(isBtn: boolean) {
    this.isTypeBtn = isBtn;
    this.isTypeImg = !isBtn;
    if (isBtn && !this.buttonText) {
      this.buttonText = 'Go to the Challenge';
    }
  }

  /**
   * To handle file change event for images
   * @param event $event
   */
  fileChangeEvent(event: any) {
    if (event.target.files[0] !== undefined) {
      this.selectedFile = event.target.files[0];
      const isValidExtension = this.validateExtension();
      if (isValidExtension) {
        const formData: FormData = new FormData();
        // flag to display progress bar
        this.progressbarDisplay = true;
        formData.append('file', this.selectedFile);
        this.commonHttpService.postWithProgress({
          uri: '/api/Assets/UploadImage',
          object: formData
        }).subscribe((response: any) => {
          if (typeof response === 'number') {
            // progress bar % while file is being uploaded
            this.dynamicProgressbar = response;
          } else if (response) {
            this.progressbarDisplay = false;
            this.dynamicProgressbar = 0;
            this.uploadedImg = response;
          }
        });
      } else {
        const isAre = imageAllowedExtension.length > 1 ? 'are' : 'is';
        const extensionErrorMessage = 'This is not a valid extension. Supported extension(s) '
          + isAre + ' : ' + imageAllowedExtension.join(',') + '.';
        const initialState = {
          msg: extensionErrorMessage,
          showCancelBtn: false
        };
        this.confModalRef = this.modalService.show(ConfirmationModelComponent,
          Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
        this.confModalSubsciber = this.confModalRef.content.onclose.subscribe((res) => {
          this.confModalRef.hide();
          this.confModalSubsciber.unsubscribe();
        });
      }
    }
  }

  /**
   * To validate extension of uploaded file
   */
  validateExtension() {
    const extensionArray = this.selectedFile.name.split('.');
    const extension = extensionArray[extensionArray.length - 1].toLowerCase();
    const isValidExtension = includes(imageAllowedExtension, extension);
    return isValidExtension;
  }

  /**
   * To save challenge with the check of change in private challenge if available
   */
  saveChallenge() {
    if (this.isPrivateChallenge && this.privateChallengeId !== this.selectedChallenge.challengeId) {
      const initialState = {
        msg: `A Private Challenge has been linked by an Administrator. Do you want to override the Private Challenge currently linked?`
      };
      this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
        Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
      this.confModalSubscription = this.confirmationModalRef.content.onclose.subscribe((status: boolean) => {
        if (status) {
          this.addChallengeBlock();
        }
        this.confirmationModalRef.hide();
      });
    } else {
      this.addChallengeBlock();
    }
  }

  /**
   * To save or update challenge block
   */
  addChallengeBlock() {
    const reqObj = {
      contentBlockId: this.contentBlockId,
      playbookId: this.playbookId,
      challengeId: this.selectedChallenge.challengeId,
      buttonText: this.isTypeBtn ? this.buttonText : null,
      onlineAssetId: this.uploadedImg ? this.uploadedImg.id : null,
    };
    if (this.challengeBlock && this.challengeBlock.id) {
      // to update
      const updateObj = { ...reqObj, id: this.challengeBlock.id };
      this.commonHttpService.putWithHeaders({
        uri: '/api/ChallengeBlocks',
        object: updateObj
      }, {
        pageId: this.pageId,
        sectionId: this.sectionId,
        playbookId: this.playbookId,
        languageId: this.languageId,
        isdraftmode: this.isdraftmode
      }).subscribe((response: ChallengeBlock) => {
        this.modalRef.content.challengeBlock = response;
        if (!this.openFromMobile) {
          this.modalRef.hide();
        } else {
          this.onclose.next(this.modalRef.content.challengeBlock);
        }
      });
    } else {
      // to save
      this.commonHttpService.postWithHeaders({
        uri: '/api/ChallengeBlocks',
        object: reqObj
      }, {
        pageId: this.pageId,
        sectionId: this.sectionId,
        playbookId: this.playbookId,
        languageId: this.languageId,
        isdraftmode: this.isdraftmode
      }).subscribe((response: ChallengeBlock) => {
        this.modalRef.content.challengeBlock = response;
        if (!this.openFromMobile) {
          this.modalRef.hide();
        } else {
          this.onclose.next(this.modalRef.content.challengeBlock);
        }
      });
    }
  }

  /**
   * Disability check for save button
   */
  disabilityCheck() {
    if (this.isTypeBtn && this.buttonText && this.selectedChallenge) {
      return false;
    } else if (this.isTypeImg && this.uploadedImg && this.selectedChallenge) {
      return false;
    }
    return true;
  }

  /**
   * To close the modal
   */
  closeModal() {
    if (!this.openFromMobile) {
      this.modalRef.hide();
    } else {
      this.onclose.next(null);
    }
  }

  ngOnDestroy() {
    if (this.confModalSubscription) {
      this.confModalSubscription.unsubscribe();
    }
  }
}
